export enum ESavedView {
  PERSONAL = 'PERSONAL',
  SHARED = 'SHARED',
}
